import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";

export const CardStyled = styling(Card)((props) => ({
  borderRadius: "10px",
  height: "100%",
  boxShadow: "0 0 0 rgb(181 181 181 / 20%)",
  height: "fit-content",
}));

export const SectionTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "24px",
  marginBottom: "15px",
}));

export const SectionContainer = styling("section")({
  overflowWrap: "anywhere",
});

export const AdditionalInfoTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "16px",
  lineHeight: "24px",
  marginBottom: "8px",
}));

export const AdditionalInfoBody = styling(Typography)((props) => ({
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "22px",
  marginBottom: "10px",
}));

export const TypographyStyled = styling(Typography)((props) => ({
  //
}));

export const DivStyled = styling(Grid)((props) => ({
  //
}));

export const ChipStyled = styling(Chip)({
  backgroundColor: Color.lightHiredlyPurple,
  marginRight: "16px",
  marginBottom: "16px",
  fontWeight: 400,
  fontSize: "14px",
  color: "#00000090",
  padding: "12.5px 16px",
});

export const BenefitTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "16px",
  lineHeight: "24px",
}));

export const BenefitBody = styling(Typography)((props) => ({
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "22px",
  marginBottom: "10px",
}));

export const BenefitContainer = styling(Grid)((props) => ({
  gap: "16px",
  borderRadius: "8px",
  border: `1px solid ${Color.grey}`,
  padding: "16px",
  minHeight: "250px",
  overflow: "hidden",
  overflowWrap: "anywhere",

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "250px",
  },
}));

export const FontAwesomeIconStyled = styling(FontAwesomeIcon)((props) => ({
  width: "24px",
  height: "24px",
}));
